import { message } from 'ant-design-vue';

export const PreparationStatus = Object.freeze({
  Queued: 'queued',
  Preparing: 'preparing',
  AwaitingConfirmation: 'awaiting_confirmation',
  Succeeded: 'succeeded',
  Failed: 'failed',
  Stale: 'stale',
});

const POLL_INTERVAL_MS = 1000;
const MAX_POLL_ERRORS = 3;
const PREPARATION_MESSAGE_KEY = 'render_preparation';
const wait = () => new Promise((resolve) => { setTimeout(resolve, POLL_INTERVAL_MS); });

export const isPreparationResponse = (response) => response?.status === 202 && response?.data?.operation_id;

export const preparationError = (operation) => Object.assign(
  new Error(operation.details?.message || 'Не удалось подготовить рендер. Повторите запуск.'),
  { response: { status: 409, data: { ...operation.details, preparation_id: operation.operation_id } } },
);

export const waitForRenderPreparation = async (response, getState, getPlan) => {
  if (!isPreparationResponse(response)) return response;
  let operation = response.data;
  let errors = 0;
  message.loading({ key: PREPARATION_MESSAGE_KEY, content: 'Подготовка файлов для рендера…', duration: 0 });
  try {
    for (;;) {
      if (operation.status === PreparationStatus.Succeeded) return await getPlan(operation.crm_plan_id);
      if (operation.status === PreparationStatus.AwaitingConfirmation) throw preparationError(operation);
      if ([PreparationStatus.Failed, PreparationStatus.Stale].includes(operation.status)) {
        const error = preparationError(operation);
        message.error(error.message);
        throw error;
      }
      await wait();
      try {
        const state = await getState(operation.crm_plan_id);
        const current = state.data.render_preparation;
        if (!current || current.operation_id !== operation.operation_id) {
          throw new Error('Состояние подготовки изменилось. Обновите страницу, чтобы проверить результат.');
        }
        operation = current;
        errors = 0;
      } catch (error) {
        errors += 1;
        if (errors >= MAX_POLL_ERRORS) {
          message.error('Не удалось проверить подготовку. Она может продолжаться. Обновите страницу.');
          throw error;
        }
      }
    }
  } finally {
    message.destroy(PREPARATION_MESSAGE_KEY);
  }
};

export const resolveRenderPreparation = async (response) => {
  if (!isPreparationResponse(response)) return response;
  const { api } = await import('@/api');
  return waitForRenderPreparation(response, api.getCrmPlanState, api.getCrmPlan3dById);
};
